module.exports = __webpack_public_path__ + "img/productBanner.c4ccf483.jpg";